module.exports = __webpack_public_path__ + "img/step1.cd253ff6.jpg";